import * as React from "react";
import { useParams } from "react-router";
import BlueprintContainer from "../../../components/Blueprints/BlueprintContainer";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";
import { buildQueryString } from "../../../store/base";
import { useFilteredBlueprints } from "../../../store/blueprints";
import { useFilteredRooms } from "../../../store/rooms";
import PageSlider from "../../Layouts/PageSlider/PageSlider";
import PremisesImageContainer from "../../../components/Details/Images/PremisesImageContainer";
import { useBrfPremises } from "../../../store/brfPremises";

const TABS = {
  BLUEPRINT: "Planritning",
  IMAGES: "Bilder",
};

export default function BrfPremisesImagesAndBlueprints() {
  const { brfPremisesId } = useParams();
  const [selectedTab, setSelectedTab] = React.useState("IMAGES");

  const [brfPremises] = useBrfPremises(brfPremisesId);

  const query = buildQueryString({
    brfpremis: brfPremisesId,
  });

  const [blueprints, blueprintsLoading] = useFilteredBlueprints(query);
  const blueprint = blueprints?.[0] || undefined;

  const roomQuery = blueprint
    ? buildQueryString({ blueprint__id: blueprint.id })
    : null;

  const [rooms, roomsLoading] = useFilteredRooms(roomQuery);

  return (
    <DetailInnerWrapper>
      <DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>{TABS[selectedTab]}</OverviewTitle>

          {/* <PageSlider
            {...{
              TABS,
              selectedTab,
              onTabSelected: (tab) => setSelectedTab(tab),
            }}
          /> */}
        </OverviewTitleWrapper>

        {/* {selectedTab === "BLUEPRINT" && (
          <BlueprintContainer
            blueprint={blueprint}
            premises={brfPremises}
            rooms={rooms || []}
          />
        )} */}

        {selectedTab === "IMAGES" && (
          <PremisesImageContainer
            kind="brfpremises"
            images={brfPremises?.images}
            instance={brfPremises}
          />
        )}
      </DetailPageBox>
    </DetailInnerWrapper>
  );
}
